export function formatCurrency(amount, currency = 'INR') {
  if (amount === null || amount === undefined || amount === '') return '-';
  const value = typeof amount === 'string' ? Number(amount) : amount;
  if (!Number.isFinite(value)) return String(amount);
  const map = {
    INR: { locale: 'en-IN', currency: 'INR' },
    USD: { locale: 'en-US', currency: 'USD' },
    EUR: { locale: 'de-DE', currency: 'EUR' },
    GBP: { locale: 'en-GB', currency: 'GBP' },
  };
  const cfg = map[currency] || map.INR;
  try {
    return new Intl.NumberFormat(cfg.locale, { style: 'currency', currency: cfg.currency, maximumFractionDigits: 2 }).format(value);
  } catch (_) {
    // Fallback simple prefix when Intl fails
    const symbol = ({ INR: '₹', USD: '$', EUR: '€', GBP: '£' })[cfg.currency] || '₹';
    return `${symbol}${value}`;
  }
}
